/**
 * `/$tenantSlug/forms/$id/print` — a form's blank pad, ready to print (Forms
 * slice F1, PRD 48 §6–§7). No cockpit shell: the trailing-underscore segment
 * parents this route to the root, as the shared document print view does.
 * The sheet's foot carries the printed code and version as text
 * (forms-print-footer, "AQF-TKT · v1"). An archived form is refused in words.
 *
 * MODULE GATE: GET /api/modules/forms/forms/{id}/print sits behind
 * `require_module("forms")` and `forms.view` on the server.
 */

import { FormsPrintScreen } from "@ken/module-forms";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { Suspense, type ReactElement } from "react";

interface PrintSearch {
  customer?: string;
}

export const Route = createFileRoute("/$tenantSlug_/forms/$id/print")({
  validateSearch: (raw: Record<string, unknown>): PrintSearch => (typeof raw["customer"] === "string" && raw["customer"] ? { customer: raw["customer"] } : {}),
  component: FormsPrintRoute,
});

function FormsPrintRoute(): ReactElement {
  const { id } = useParams({ from: "/$tenantSlug_/forms/$id/print" });
  const search = useSearch({ from: "/$tenantSlug_/forms/$id/print" });
  return (
    <Suspense fallback={null}>
      <FormsPrintScreen formId={id} customer={search.customer} />
    </Suspense>
  );
}
